import isomorphicFetch from 'isomorphic-fetch';
import { ClientConfig } from 'client/configuration';
import { IS_NODE } from 'client/utils/environment';
import { APIClient } from './api-client';

const fetch = IS_NODE ? isomorphicFetch : undefined;

export const CapOneAPI = new APIClient(() => ClientConfig.get('carBuying').capOneApiUrl, {
  fetch,
});

export const CapOneAPIV2 = new APIClient(() => ClientConfig.get('carBuying').capOneApiUrlBypassApiGateway, {
  fetch,
});
